module.exports = __webpack_public_path__ + "img/help.9056e096.svg";